export default {
  401: 'Пользователь не найден',
};
